import $ from "jquery";

var $document = $(document);

$document.on('show.bs.modal', '.modal', function(ev) {
  var remote = $(ev.relatedTarget).attr('href');
  if (remote) {
    var target = $(ev.currentTarget);
    var content = target.find('.modal-content');
    if (content.children().length) {
      content
        .empty()
        .load(remote, $.proxy(function() {
          target.trigger('loaded.bs.modal');
        }, this));
    }
  }
});

$('[data-href]').on('click', function(ev) {
  ev.preventDefault();
  window.location = $(this).data('href');
});

var scroll_offset = { top: -80, left: 0 };

$('[data-scrollto]').on('click', function(ev) {
  // if there's an element with this id on the page with children
  if ($(this.hash).length) {
    $.scrollTo(this.hash, 1500, { offset: scroll_offset });
  } else {
    window.location = "/" + this.hash;
  }
  ev.preventDefault();
});

// site_nav_offset_top = null
// site_nav_el = $("#site-nav")

// $(window).on('resize', function() {
//   if (typeof site_nav_el.offset() != 'undefined' && !site_nav_el.hasClass("affix")) {
//     var v = Math.round(site_nav_el.offset().top);
//     site_nav_offset_top = v;
//   }
// });

// $("#site-nav, #site-nav-bg").affix({
//   offset: {
//     top: function() {
//       site_nav_offset_top = site_nav_offset_top || Math.round(site_nav_el.offset().top);
//       return site_nav_offset_top;
//     },
//     bottom: 1
//   }
// });

// soft scroll to hash on page load
// workaround for site-nav positioning, doesn't
// position correctly when visiting an anchor
$document.ready(function() {
  var elem = $(window.location.hash);
  if (elem) {
    setTimeout(function() {
      window.scrollTo(0, 0);
    }, 1);
    $('.assets, .asset-grid').imagesLoaded(function() {
      $.scrollTo(window.location.hash, 500, { offset: scroll_offset });
    });
  }
}); 